/* eslint-disable */
const UrlReg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/

export function CheckUrl(url) {
  return UrlReg.test(url)
}
